import * as angular from 'angular';
import { HelloComponent } from './hello.component';
import { QuickVaultCreditCardPaymentButtonComponent } from './quickVaultCreditCardPaymentButton.component';
import { QuickWebCreditCardPaymentButtonComponent } from './quickWebCreditCardPaymentButton.component';
import { rsaEncrypt } from '@petsure/core';

export const angularjsModule = angular
    .module('PetsurePaymentModule', [])
    .service('rsaEncrypt', function() { return rsaEncrypt })
    .component('helloComponent', HelloComponent)
    .component('quickVaultCreditCardPaymentButton', QuickVaultCreditCardPaymentButtonComponent)
    .component('quickWebCreditCardPaymentButton', QuickWebCreditCardPaymentButtonComponent)
    .name;
